// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_dx-2";
export var aiChatCartContainerExit = "_dx-4";
export var aiChatContainerLarge = "_dx-0";
export var aiChatContainerSmall = "_dx-1";
export var aiChatIcon = "_dx-6";
export var slideInFromRight = "_dx-3";
export var slideOutToRight = "_dx-5";